export * from '@fhs/routing/src/routes/(product)/menu/[slug]/_layout';
export { default } from '@fhs/routing/src/routes/(product)/menu/[slug]/_layout';
